import React from 'react';

import {registrationCn} from '../index';

const RegFormRow = ({ children }) => {
  return(
    <div className={registrationCn('Row')}>
      { children }
    </div>
  )
}

export default RegFormRow;
